// We don't want to set contentHtmlParser in the barrel file (index export *)
// This way we can lazyload the component and the function

import type { ReactNode } from 'react'

import { Content } from '../../../Content'
import { contentHtmlParser } from '../../../Content/contentHtmlParser'

export const ProxyContent = ({ content }: { content: string }): ReactNode => {
  const parsed = contentHtmlParser(content.replaceAll('\n', ''))

  return <Content nodes={parsed} />
}
